import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RoleUnauthorizeModule } from './partial/role-unauthorize/role-unauthorize.module';

import { SharedModule } from './shared/shared.module';
import { DxcModule } from './dxc.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslationService } from './services/translation.service';

import { ExternalModule } from './external.module';

import { OAuthModule } from 'angular-oauth2-oidc';
import { LocalStorageModule } from 'angular-2-local-storage';
import { LoginService } from './services/login.service';
import { DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AnalyticsComponent } from './partial/analytics/analytics.component';

export function translationInitializer(translationService: TranslationService) {
  return function () {
    return translationService.init('en');
  };
}
export function createTranslateLoader(http: HttpClient) {
  const RESOURCE_SERVER_URL: string = environment.RESOURCE_SERVER_URL;
  return new TranslateHttpLoader(
    http,
    RESOURCE_SERVER_URL + '/assets/i18n/',
    '.json'
  );
}

@NgModule({
  declarations: [AppComponent,AnalyticsComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RoleUnauthorizeModule,
    BrowserAnimationsModule,
    DxcModule,
    ExternalModule,
    SharedModule,
    OAuthModule.forRoot(),
    HttpClientModule,
    LocalStorageModule.forRoot({
      prefix: 'example',
      storageType: 'localStorage',
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),

    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [
    OAuthModule,
    { provide: MAT_DIALOG_DATA, useValue: {} },
    LoginService,
    {
      provide: APP_INITIALIZER,
      useFactory: translationInitializer,
      deps: [TranslationService],
      multi: true,
    },
    DatePipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
export function HttpLoaderFactory(http: HttpClient) {
  const RESOURCE_SERVER_URL: string = environment.RESOURCE_SERVER_URL;
  return new TranslateHttpLoader(http, RESOURCE_SERVER_URL + '/assets/i18n/');
}
